import React from 'react'
import PropTypes from 'prop-types'

const NoEntry = ({ text }) => (<p className="NoEntry">{text}</p>)

NoEntry.propTypes = {
  text: PropTypes.string.isRequired,
}
export default NoEntry